import { InstitutionalCommunicationForm } from "../../components/Forms/InstitutionalCommunicationForm";

export const NewInstitutionalCommunication = () => {
  return (
    <div className="p-card gap-4 p-3 align-self-center">
      <h1 className="text-center text-3xl">Crear noticia o beneficio</h1>
      <InstitutionalCommunicationForm />
    </div>
  );
};
